import types from 'constants/actionTypes';
import { combineReducers } from 'redux';

const initialState = {
  byId: {},
  selectedChart: '',
};

const byId = (state, { type, payload }) => {
  if (typeof state === 'undefined') {
    return initialState.byId;
  }

  switch (type) {
    case types.GET_MODEL_PIPELINE_REQUEST_SUCCESS:
      let updatedState = { ...state };
      const modelId = Object.keys(payload)[1];
      updatedState[modelId] = payload[modelId];
      return updatedState;
    default:
      return state;
  }
};

const selectedChart = (state, { type, payload }) => {
  if (typeof state === 'undefined') return initialState.selectedChart;

  switch (type) {
    case types.UPDATE_SELECTED_CHART:
      return payload;
    default:
      return state;
  }
};

export default combineReducers({
  selectedChart,
  byId,
});
